import { render, staticRenderFns } from "./PremiumMessageDetail.vue?vue&type=template&id=7d9ce130&scoped=true&"
import script from "./PremiumMessageDetail.vue?vue&type=script&lang=js&"
export * from "./PremiumMessageDetail.vue?vue&type=script&lang=js&"
import style0 from "./PremiumMessageDetail.vue?vue&type=style&index=0&id=7d9ce130&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9ce130",
  null
  
)

export default component.exports